import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { SharedService } from '../shared.service';
import { ChangeDetectorRef, Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { NgClass } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { NavbarComponent } from '../navbar/navbar.component';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-content-layout',
  imports: [
    NgClass,
    RouterOutlet,
    SidebarComponent,
    NavbarComponent
  ],
  templateUrl: './content-layout.component.html',
  styleUrl: './content-layout.component.scss',
})


export class ContentLayoutComponent {
  @Output() isCollaseped = new EventEmitter<boolean>(false);
  isCollasepedflag: boolean = JSON.parse(localStorage.getItem('isCollasepedflag') || 'false');;
  title = 'vas-project';
  isExpanded: boolean = false;   // For expanded layout
  isHover: boolean = false;      // For hover case
  isMobile: boolean = false;
  isMobileView: boolean = false;
  isMobileSearch: boolean = false;
  isNavbarSidebaeVisible: boolean = true;
  // isCollaseped: boolean = false;

  MENUITEMS: any[] = []
  constructor(private sharedService: SharedService, private router: Router) { }
  // For mobile view case
  ngOnInit() {

    const matchUrl = "/dealer/login";
    if (this.router.url.includes(matchUrl)) {
      this.isNavbarSidebaeVisible = false;
      // console.log('this.router.url1');
    } else {
      this.isNavbarSidebaeVisible = true;
      // console.log('this.router.url2')
    }

    // Detect mobile view on page load
    this.detectMobileView(false);

    // Optionally listen for window resize events
    window.addEventListener('resize', () => {
      this.detectMobileView(false);
    });
    this.sharedService.toggleState$.subscribe((value: boolean) => {
      this.isMobile = value;
    });
    // this.sharedService.toggleSidebar$.subscribe((value: boolean) => {
    //   this.isCollaseped = value;
    // });
    this.getCollasepseData('');
  }
  ngDocheck() {
    this.detectMobileView(false);
    // Optionally listen for window resize events
    window.addEventListener('resize', () => {
      this.detectMobileView(false);
    });
  }
  toggleExpanded() {
    this.isExpanded = !this.isExpanded;
  }
  mouseOverleave() {
    this.isHover = !this.isExpanded;
  }
  // You can detect mobile view using screen size
  detectMobileView(val: boolean) {
    this.isMobile = val;
    this.isMobileView = window.innerWidth <= 1026;
  }
  getActivemenu(item: any): any {
    item.isOpen = !item.isOpen;
  }
  getActiveChild(parent: any, child: any, event: Event) {
    console.log(parent, 'parent')
    this.MENUITEMS?.forEach(menuItem => {
      menuItem.active = false
      if (menuItem?.children) {
        menuItem.children.forEach((childItem: any) => childItem.active = false);
      }
    });
    // Prevent parent click event from firing
    event.stopPropagation();
    // Reset all child items of the clicked parent
    parent?.children?.forEach((childItem: any) => childItem.active = false);
    // Set the clicked child item to active
    child.active = true;
    // Ensure the parent is also set to active
    parent.active = true;
  }
  SerachMbInfo() {
    this.isMobileSearch = !this.isMobileSearch
  }
  getCollasepseData(event: any) {
    // if (this.isMobileView) {
    //   this.isCollaseped=false
    // } else {
    //   const isActive:boolean = JSON.parse(localStorage.getItem('isCollasepedflag') || 'false');
    //   this.isCollaseped = isActive;
    // }
    console.log(event, "My event")
  }
  togglecollapsedScreen(isCollaseped: boolean) {
    if (this.isMobileView) {
      this.isCollasepedflag = false
    } else {
      this.isCollasepedflag = !isCollaseped;
      this.sharedService.gettoggleSidebar(this.isCollasepedflag)
      this.isCollaseped.emit(this.isCollasepedflag);
    }
  }
}